import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'

import imgHero from '../../images/recommends_04_top5_candidates.png'
import imgSectionOne from '../../images/recommends_05_smarter_decision.png'
import imgSectionTwo from '../../images/recommends_03_role_specific.png'
import imgSectionThree from '../../images/recommends_02_your_team_decide.png'
import imgSectionFour from '../../images/recommends_06_standard_talent.png'

import { accesslog } from '../../helpers/global'
import { getWeeklyDemoDataAsync } from '../../actions/global'

class AstrntRecommendsDetail extends React.Component {
  async componentDidMount() {
    window.scrollTo(0, 0)
    if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
      await this.props.getWeeklyDemoDataAsync()
    }
  }

  render() {
    const { weeklyDemoData } = this.props
    return (
      <div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />

        <div className="banner ai">
          <section>
            <div className="ban-text ai">
              <div className="title-1">ASTRNT Recommends</div>
              <div className='content-desc'>
                Hundreds of CVs. Hours of video interviews. Let ASTRNT take the first pass. Get your top 5
                candidates ranked by assessment data, video interview scores, and role fit. AI-powered,
                human-verified.
              </div>

              <div className={`ban-link`}>
                <Link to={{pathname: `/talent-acquisition/astrnt-recommends`, query: { plan: 'free' }}} className="try"
                  onClick={() => accesslog('astrnt-recommends-detail', 'button_register', {title: 'Experience Talent Recommendations'})}
                >Experience Talent Recommendations</Link>
                <a onClick={() => {
                  accesslog('astrnt-recommends-detail', 'button_talk_to_an_expert');
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                }} className="request-demo-logged">Talk to an Expert</a>
              </div>
              <a href="#" className="vid-msg" style={{top: '65%'}}>
                <img src={imgHero} style={{maxWidth: '550px'}} />
              </a>
            </div>
          </section>
        </div>

        <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionOne} />
              </div>
            </div>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{fontWeight: '700'}}>
                    Smarter Decision: Built on Real Assessment Data
                  </h2>
                  <p className='m-b-30'>
                    ASTRNT Recommends turns assessment outcomes and role requirements into a clear, ranked
                    shortlist of talents. Instead of starting from a long list, teams see who best fits the role
                    first, supported by consistent signals.
                  </p>
                  <ul>
                    <li><i className="fas fa-check" />Combines CV, psychometric assessment, and video interview scores into one fit score</li>
                    <li><i className="fas fa-check" />Matches talents against your role's competency framework and job description</li>
                    <li><i className="fas fa-check" />Clear summary view for each recommended talents</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="section-white" style={{position: 'relative'}}>
          <section className='flex-container'>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{fontWeight: '700'}}>
                    Every Recommendation is Role-Specific
                  </h2>
                  <p className='m-b-30'>
                    Recommendations aren't generic. They're built for the exact role you're hiring for. ASTRNT
                    Recommends aligns assessment content, scoring weight, and job requirements to the
                    competencies that role actually needs, so every talent is measured against the same,
                    relevant benchmark.
                  </p>
                  <ul>
                    <li><i className="fas fa-check" />Recommendations based on each role's job description and competencies</li>
                    <li><i className="fas fa-check" />Every talent for the same role measured against the same requirements</li>
                    <li><i className="fas fa-check" />Works for any role from day one</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionTwo} />
              </div>
            </div>
          </section>
        </div>

        <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionThree} />
              </div>
            </div>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{fontWeight: '700'}}>
                    ASTRNT Recommends. Your Team Decides.
                  </h2>
                  <p className='m-b-30'>
                    Every recommendation comes with a clear justification (which scores, traits, and interview
                    signals drove the ranking), so your team can see the "why" behind each name and override it
                    anytime.
                  </p>
                  <ul>
                    <li><i className="fas fa-check" />Match score and ranking generated automatically</li>
                    <li><i className="fas fa-check" />Justification breakdown for every recommended talent, never a black-box score</li>
                    <li><i className="fas fa-check" />Make decision faster</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="section-white" style={{position: 'relative'}}>
          <section className='flex-container'>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{fontWeight: '700'}}>
                    Same Standard, Every Talent
                  </h2>
                  <p className='m-b-30'>
                    Because every talent is scored against the same criteria and data, ASTRNT Recommends helps
                    remove first-impression bias from early shortlisting. Decisions are backed by structured,
                    auditable data, making it easier to explain and defend every shortlisting choice to
                    stakeholders.
                  </p>
                  <ul>
                    <li><i className="fas fa-check" />Identical scoring criteria applied to every talent for the same role</li>
                    <li><i className="fas fa-check" />Recommendations built from structured data, not gut feeling or resume formatting</li>
                    <li><i className="fas fa-check" />Full audit trail you can show stakeholders to justify each decision</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='flex-item-right' style={{zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionFour} />
              </div>
            </div>
          </section>
        </div>

        <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Ready to Hire with ASTRNT Recommends?</h1>
              <h4>Reduce bias and shortlist faster with role-based, AI-powered talent recommendations.</h4>
              <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link to={{pathname: `/talent-acquisition/astrnt-recommends`, query: { plan: 'free' }}} className="try"
                    onClick={() => accesslog('astrnt-recommends-detail', 'button_register', {title: 'Experience Talent Recommendations'})}
                  >Experience Talent Recommendations</Link>
                  <a onClick={() => {
                    accesslog('astrnt-recommends-detail', 'button_talk_to_an_expert');
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  }} className="request-demo-logged">Talk to an Expert</a>
                </div>
                <a className={`request-demo-logged${weeklyDemoData && weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                  href={weeklyDemoData && weeklyDemoData.webinar_link} target='_blank'
                  onClick={() => accesslog('astrnt-recommends-detail', 'button_register_for_demo', {title: weeklyDemoData && weeklyDemoData.title})}
                > Register for Demo </a>
              </div>
            </div>
          </section>
        </div>

        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    globalGetLanguages: state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AstrntRecommendsDetail)
